/**
 * Internal dependencies
 */

function Button({
		type = 'button',
		onClick = () => {},
		selected = false,
		disabled = false,
		customClass,
		children,
}) {
	const classes = [
		'dpf_button',
		selected && 'dpf_button--selected',
		customClass && customClass,
	];

	const handleClick = (e) => {
		e.preventDefault();
		onClick(e);
	}

	return (
		<button
			className={classes.filter(Boolean).join(' ')}
			disabled={disabled}
			onClick={(e) => handleClick(e)}
			type={type}
		>
			{ children }
		</button>
	)
}

export default Button;
